<template>
  <v-container>
    <v-layout row wrap></v-layout>
    <iframe
      id="pdf"
      target="_blank"
      frameborder="0"
      style="overflow:hidden;overflow-x:hidden;overflow-y:hidden;height:100%;width:100%;position:absolute;top:0px;left:0px;right:0px;bottom:0px"
      height="100%"
      width="100%"
    ></iframe>
  </v-container>
</template>

<script>
/* eslint-disable */
import { mapActions } from "vuex";
import { degrees, PDFDocument, rgb, StandardFonts } from "pdf-lib";
import DocumentService from "@/services/DocumentService";
import fontkit from "@pdf-lib/fontkit";
import SettingService from "@/services/SettingService";
import moment, { months } from "moment";
import numeral from "numeral";
import { async } from "q";
export default {
  data() {
    return {
      companybuilding: "", //อาคาร
      companyroom_no: "", //ห้อง
      companyfloor: "", //ชั้น
      companyvillage: "", //หมู่บ้าน
      companyhouse_no: "", //บ้านเลขที่
      companyvillage_no: "", //หมู่ที่
      companyalley_lane: "", //ตรอก/ซอย
      companyroad: "", //ถนน
      companysubdistrict_subarea: "", //ตำบล/แขวง
      companydistrict_area: "", //อำเภอ/เขต
      companyprovince: "", //จังหวัด
      companypostcode: "", //รหัสไปรษณีย์
      companyName: "",
      taxpayer_number: "",
      year: "",
      emps: 0,
      totalDeductTax: "",
      totalEarning: "",
      json: {},
      newjson: {},
      index: 0,
      jsonperson: {},
      texttax: "",
      tax:0,
    };
  },
  async created() {
    this.year = this.$route.params.year;
    this.branch = this.$route.params.branch;
    this.department = this.$route.params.department;
    this.doc_ref = this.$route.params.empcode;
    await this.process();
     //await this.pdf();
  },

  methods: {
    groupBy(array, key) {
      const result = {};
      array.forEach(item => {
        if (!result[item[key]]) {
          result[item[key]] = [];
        }
        result[item[key]].push(item);
      });
      return result;
    },
    async getData() {
      let v = this;
      let branchs = "";
      if(this.branch == "ALL"){
        branchs = "";
         try {
        let WHTkor = await DocumentService.getTaxDetailByYearAllEmp(
          this.year,
          branchs,
           this.department
        );
        var total_person = this.groupBy(WHTkor.data.details, "emp_code");
        // for (var key in total_person) {
        //   this.emps += 1;
        // }
        this.totalDeductTax = WHTkor.data.total_tax;
        this.totalEarning = WHTkor.data.total_earning;
      } catch (err) {
        console.log(err);
      }
      }else{
        branchs = this.branch;
         try {
        let WHTkor = await DocumentService.getTaxDetailByYearAllEmp(
          this.year,
          branchs,
          this.department
        );
        var total_person = this.groupBy(WHTkor.data.details, "emp_code");
        // for (var key in total_person) {
        //   this.emps += 1;
        // }
        this.totalDeductTax = WHTkor.data.total_tax;
        this.totalEarning = WHTkor.data.total_earning;
      } catch (err) {
        console.log(err);
      }
      }
     
    },
    process() {
      let v = this;
      let branchs = "";
      if(this.branch == "ALL"){
        branchs = "";
            DocumentService.getTaxDetailByYearAllEmp(
          this.year,
          branchs,
          this.department
        )
          .then(res => {
            console.log(res);
            this.json = res.data;
            this.tabledata = true;
            console.log("doc_ref : ", this.doc_ref);
            var empcode = this.doc_ref.split(",");
            console.log("emp_code: ", empcode);
            console.log("this.json: ", this.json);
            //** empcode person **//
            this.jsonperson.details = [];
            this.json.details.forEach(element => {
              empcode.forEach(ele => {
                if (element.emp_code == ele) {
                  this.jsonperson.details.push({
                    emp_code: element.emp_code,
                    id_card: element.id_card,
                    emp_name: element.emp_name,
                    payDate: element.payDate,
                    address: element.address,
                    social_pay: element.social_pay,
                    earning: element.earning,
                    tax_pay: element.tax_pay
                  });
                }
              });
            });

          console.log("jsonperson", this.jsonperson);
            //**new array **//
            this.newjson.from_date = this.json.from_date;
            this.newjson.to_date = this.json.to_date;
            this.newjson.total_earning = this.json.total_earning;
            this.newjson.total_tax = this.json.total_tax;
            this.newjson.details = [];
            var sumearning = 0;
            var sumtax_pay = 0;
            var sumsocial_pay = 0;
            this.newjson.details = [];
            const unique = this.groupBy(this.jsonperson.details, "emp_code");

            console.log("unique", unique);
            let keys = "";
            let index = 0;
            for (var key in unique) {
              //console.log("key: ", key);
              let emp_code = "";
              let id_card = "";
              let emp_name = "";
              let payDate = "";
              let address = "";
              let j = 0;
              sumearning = 0;
              sumtax_pay = 0;
              sumsocial_pay = 0;
              unique[key].forEach(element => {
                emp_code = element.emp_code;
                id_card = element.id_card;
                emp_name = element.emp_name;
                payDate = element.payDate;
                address = element.address;
                sumsocial_pay += element.social_pay;
                sumearning += element.earning;
                sumtax_pay += element.tax_pay;
                j++;
              });
              this.newjson.details.push({
                emp_code: emp_code,
                id_card: id_card,
                emp_name: emp_name,
                payDate: payDate,
                address: address,
                social_pay: sumsocial_pay,
                earning: sumearning,
                tax_pay: sumtax_pay
              });
            }
            this.pdf();
            console.log("json: ", this.json);
            console.log("new json: ", this.newjson);
          })
          .catch(err => {
            console.log(err);
            0;
          });
      }else{
         branchs = this.branch;
             DocumentService.getTaxDetailByYearAllEmp(
          this.year,
          branchs,
          this.department
        )
          .then(res => {
            console.log(res);
            this.json = res.data;
            this.tabledata = true;
            console.log("doc_ref : ", this.doc_ref);
            var empcode = this.doc_ref.split(",");
            console.log("emp_code: ", empcode);
            console.log("this.json: ", this.json);
            //** empcode person **//
            this.jsonperson.details = [];
            this.json.details.forEach(element => {
              empcode.forEach(ele => {
                if (element.emp_code == ele) {
                  this.jsonperson.details.push({
                    emp_code: element.emp_code,
                    id_card: element.id_card,
                    emp_name: element.emp_name,
                    payDate: element.payDate,
                    address: element.address,
                    social_pay: element.social_pay,
                    earning: element.earning,
                    tax_pay: element.tax_pay
                  });
                }
              });
            });

          console.log("jsonperson", this.jsonperson);
            //**new array **//
            this.newjson.from_date = this.json.from_date;
            this.newjson.to_date = this.json.to_date;
            this.newjson.total_earning = this.json.total_earning;
            this.newjson.total_tax = this.json.total_tax;
            this.newjson.details = [];
            var sumearning = 0;
            var sumtax_pay = 0;
            var sumsocial_pay = 0;
            this.newjson.details = [];
            const unique = this.groupBy(this.jsonperson.details, "emp_code");

            console.log("unique", unique);
            let keys = "";
            let index = 0;
            for (var key in unique) {
              //console.log("key: ", key);
              let emp_code = "";
              let id_card = "";
              let emp_name = "";
              let payDate = "";
              let address = "";
              let j = 0;
              sumearning = 0;
              sumtax_pay = 0;
              sumsocial_pay = 0;
              unique[key].forEach(element => {
                emp_code = element.emp_code;
                id_card = element.id_card;
                emp_name = element.emp_name;
                payDate = element.payDate;
                address = element.address;
                sumsocial_pay += element.social_pay;
                sumearning += element.earning;
                sumtax_pay += element.tax_pay;
                j++;
              });
              this.newjson.details.push({
                emp_code: emp_code,
                id_card: id_card,
                emp_name: emp_name,
                payDate: payDate,
                address: address,
                social_pay: sumsocial_pay,
                earning: sumearning,
                tax_pay: sumtax_pay
              });
            }
            this.pdf();
            console.log("json: ", this.json);
            console.log("new json: ", this.newjson);
          })
          .catch(err => {
            console.log(err);
            0;
          });
      }
    
      
    },

    async getdataCompany() {
      const tmpResult = await SettingService.getDataCompany();
      this.companyName = tmpResult.data.content[0].companyname;
      this.companybuilding = tmpResult.data.content[0].building; //อาคาร
      this.companyroom_no = tmpResult.data.content[0].room_no; //ห้อง
      this.companyfloor = tmpResult.data.content[0].floor; //ชั้น
      this.companyvillage = tmpResult.data.content[0].village; //หมู่บ้าน
      this.companyhouse_no = tmpResult.data.content[0].house_no; //บ้านเลขที่
      this.companyvillage_no = tmpResult.data.content[0].village_no; //หมู่ที่
      this.companyalley_lane = tmpResult.data.content[0].alley_lane; //ตรอก/ซอย
      this.companyroad = tmpResult.data.content[0].road; //ถนน
      this.companysubdistrict_subarea =
        tmpResult.data.content[0].subdistrict_subarea; //ตำบล/แขวง
      this.companydistrict_area = tmpResult.data.content[0].district_area; //อำเภอ/เขต
      this.companyprovince = tmpResult.data.content[0].province; //จังหวัด
      this.companypostcode = tmpResult.data.content[0].postcode; //รหัสไปรษณีย์
      this.taxpayer_number = tmpResult.data.content[0].taxpayer_number;
    },
    async getCopyDoc(pdfDoc, PDFDocument, existingPdfBytes, srcDoc) {
      const copypage = await pdfDoc.copyPages(srcDoc, [0]);
      console.log("33333");
      return copypage;
    },
    formatNumber(val) {
      var result = numeral(val).format("0,00");
      //console.log("string: ", string)
      return result;
    },
    async pdf() {
      const url = "/static/pdf/approve_wh3_081156.pdf";
      const existingPdfBytes = await fetch(url).then(res => res.arrayBuffer());
      const pdfDoc = await PDFDocument.load(existingPdfBytes);
      const srcDoc = await PDFDocument.load(existingPdfBytes);
      const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica);
      pdfDoc.registerFontkit(fontkit);
      const urlfont = "/static/Sarabun-Regular.ttf";
      const fontBytes = await fetch(urlfont).then(res => res.arrayBuffer());
      const customFont = await pdfDoc.embedFont(fontBytes);

      let i = 0;
      let k = 0;
      let v = this;

      await this.getdataCompany();
      console.log("getdataCompany: ", v.newjson.details.length);
     // await this.newjson.details.forEach(async (element, index) => {
      for (var x = 1; x < v.newjson.details.length; x++) {
        console.log("111");
        var [copyPage] = await v.getCopyDoc(
          pdfDoc,
          PDFDocument,
          existingPdfBytes,
          srcDoc
        );

        pdfDoc.addPage(copyPage);
        console.log("222");
      }
       //});

      setTimeout(async () => {
        var pages = pdfDoc.getPages();

        console.log(v.newjson.details.length);
        await v.newjson.details.forEach(async (element, index) => {
          if (index < v.newjson.details.length) {
            var firstPage = pages[index];
            console.log("index: ",index);
            console.log(firstPage);
            var { width, height } = firstPage.getSize();
            // เล่มที่
            // firstPage.drawText("001", {
            //   x: 530,
            //   y: 783 ,
            //   size: 10,
            //   font: customFont,
            //   color: rgb(0, 0, 0),
            // });
            //เลขที่

            firstPage.drawText("00" + (index + 1), {
              x: 530,
              y: 768,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });

            //เลขประจำตัวผู้เสียภาษีอาการ(13 หลัก)
            if (this.taxpayer_number != null) {
              firstPage.drawText("" + this.taxpayer_number.substring(0, 1), {
                x: 378,
                y: 748,
                size: 10,
                font: customFont,
                color: rgb(0, 0, 0)
              });
              firstPage.drawText("" + this.taxpayer_number.substring(1, 2), {
                x: 396,
                y: 748,
                size: 10,
                font: customFont,
                color: rgb(0, 0, 0)
              });
              firstPage.drawText("" + this.taxpayer_number.substring(2, 3), {
                x: 408,
                y: 748,
                size: 10,
                font: customFont,
                color: rgb(0, 0, 0)
              });
              firstPage.drawText("" + this.taxpayer_number.substring(3, 4), {
                x: 420,
                y: 748,
                size: 10,
                font: customFont,
                color: rgb(0, 0, 0)
              });
              firstPage.drawText("" + this.taxpayer_number.substring(4, 5), {
                x: 432,
                y: 748,
                size: 10,
                font: customFont,
                color: rgb(0, 0, 0)
              });
              firstPage.drawText("" + this.taxpayer_number.substring(5, 6), {
                x: 451,
                y: 748,
                size: 10,
                font: customFont,
                color: rgb(0, 0, 0)
              });
              firstPage.drawText("" + this.taxpayer_number.substring(6, 7), {
                x: 462,
                y: 748,
                size: 10,
                font: customFont,
                color: rgb(0, 0, 0)
              });
              firstPage.drawText("" + this.taxpayer_number.substring(7, 8), {
                x: 474,
                y: 748,
                size: 10,
                font: customFont,
                color: rgb(0, 0, 0)
              });
              firstPage.drawText("" + this.taxpayer_number.substring(8, 9), {
                x: 486,
                y: 748,
                size: 10,
                font: customFont,
                color: rgb(0, 0, 0)
              });
              firstPage.drawText("" + this.taxpayer_number.substring(9, 10), {
                x: 498,
                y: 748,
                size: 10,
                font: customFont,
                color: rgb(0, 0, 0)
              });
              firstPage.drawText("" + this.taxpayer_number.substring(10, 11), {
                x: 517,
                y: 748,
                size: 10,
                font: customFont,
                color: rgb(0, 0, 0)
              });
              firstPage.drawText("" + this.taxpayer_number.substring(11, 12), {
                x: 529,
                y: 748,
                size: 10,
                font: customFont,
                color: rgb(0, 0, 0)
              });
              firstPage.drawText("" + this.taxpayer_number.substring(12, 13), {
                x: 548,
                y: 748,
                size: 10,
                font: customFont,
                color: rgb(0, 0, 0)
              });
            }
            //ชื่อบริษัท
            firstPage.drawText("" + this.companyName, {
              x: 60,
              y: 732,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            //เลขประจำตัวผู้เสียภาษีอาการ

            firstPage.drawText("0", {
              x: 422,
              y: 732,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            firstPage.drawText("1", {
              x: 440,
              y: 732,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            firstPage.drawText("2", {
              x: 452,
              y: 732,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            firstPage.drawText("3", {
              x: 464,
              y: 732,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            firstPage.drawText("4", {
              x: 476,
              y: 732,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            firstPage.drawText("5", {
              x: 494,
              y: 732,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            firstPage.drawText("6", {
              x: 506,
              y: 732,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            firstPage.drawText("7", {
              x: 518,
              y: 732,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            firstPage.drawText("8", {
              x: 530,
              y: 732,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            firstPage.drawText("9", {
              x: 548,
              y: 732,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });

            //ที่อยู่
            firstPage.drawText(
              "" +
                this.companyhouse_no +
                " ตำบล " +
                this.companysubdistrict_subarea +
                "    อำเภอ " +
                this.companydistrict_area +
                "    จังหวัด " +
                this.companyprovince +
                "    " +
                this.companypostcode,
              { x: 60, y: 708, size: 10, font: customFont, color: rgb(0, 0, 0) }
            );

            //เลขประจำตัวผู้เสียภาษีอาการ(ผู้ถูกหัก13 หลัก)
            let id_card = element.id_card;
            if (id_card != null) {
              firstPage.drawText("" + id_card.substring(0, 1), {
                x: 379,
                y: 679,
                size: 10,
                font: customFont,
                color: rgb(0, 0, 0)
              });
              firstPage.drawText("" + id_card.substring(1, 2), {
                x: 397,
                y: 679,
                size: 10,
                font: customFont,
                color: rgb(0, 0, 0)
              });
              firstPage.drawText("" + id_card.substring(2, 3), {
                x: 408,
                y: 679,
                size: 10,
                font: customFont,
                color: rgb(0, 0, 0)
              });
              firstPage.drawText("" + id_card.substring(3, 4), {
                x: 420,
                y: 679,
                size: 10,
                font: customFont,
                color: rgb(0, 0, 0)
              });
              firstPage.drawText("" + id_card.substring(4, 5), {
                x: 432,
                y: 679,
                size: 10,
                font: customFont,
                color: rgb(0, 0, 0)
              });
              firstPage.drawText("" + id_card.substring(5, 6), {
                x: 451,
                y: 679,
                size: 10,
                font: customFont,
                color: rgb(0, 0, 0)
              });
              firstPage.drawText("" + id_card.substring(6, 7), {
                x: 463,
                y: 679,
                size: 10,
                font: customFont,
                color: rgb(0, 0, 0)
              });
              firstPage.drawText("" + id_card.substring(7, 8), {
                x: 475,
                y: 679,
                size: 10,
                font: customFont,
                color: rgb(0, 0, 0)
              });
              firstPage.drawText("" + id_card.substring(8, 9), {
                x: 487,
                y: 679,
                size: 10,
                font: customFont,
                color: rgb(0, 0, 0)
              });
              firstPage.drawText(
                "" + id_card.substring(9, 10),
                {
                  x: 499,
                  y: 679,
                  size: 10,
                  font: customFont,
                  color: rgb(0, 0, 0)
                }
              );
              firstPage.drawText(
                "" + id_card.substring(10, 11),
                {
                  x: 517,
                  y: 679,
                  size: 10,
                  font: customFont,
                  color: rgb(0, 0, 0)
                }
              );
              firstPage.drawText(
                "" + id_card.substring(11, 12),
                {
                  x: 529,
                  y: 679,
                  size: 10,
                  font: customFont,
                  color: rgb(0, 0, 0)
                }
              );
              firstPage.drawText(
                "" + id_card.substring(12, 13),
                {
                  x: 548,
                  y: 679,
                  size: 10,
                  font: customFont,
                  color: rgb(0, 0, 0)
                }
              );
            }
            // เลขประจำตัวผู้เสียภาษีอาการ(ผู้ถูกหัก)

            firstPage.drawText("", {
              x: 423,
              y: 660,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            firstPage.drawText("", {
              x: 441,
              y: 660,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            firstPage.drawText("", {
              x: 452,
              y: 660,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            firstPage.drawText("", {
              x: 463,
              y: 660,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            firstPage.drawText("", {
              x: 476,
              y: 660,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            firstPage.drawText("", {
              x: 495,
              y: 660,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            firstPage.drawText("", {
              x: 507,
              y: 660,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            firstPage.drawText("", {
              x: 519,
              y: 660,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            firstPage.drawText("", {
              x: 530,
              y: 660,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            firstPage.drawText("", {
              x: 549,
              y: 660,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });

            //ชื่อ-นามสกุล
            firstPage.drawText("" + element.emp_name, {
              x: 60,
              y: 660,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            //ที่อยู่
            firstPage.drawText("" + element.address, {
              x: 60,
              y: 633,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            //ลำดับที่
            firstPage.drawText("1", {
              x: 100,
              y: 605,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            //เลือกเอกสาร
            firstPage.drawText("X", {
              x: 212,
              y: 605,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            //ประเภทเงินได้เงินเดือน(วัน)
            let  date =  moment(element.payDate).format("DD/MM/YYYY");
            firstPage.drawText("" + date, {
              x: 350,
              y: 535,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            // เงินเดือน
            let earning = this.thousandSep(element.earning).split(".");
            if (earning[0].length >= 13) {
              firstPage.drawText("1" + earning[0], {
                x: 440 - 5 * (earning[0].length - 4) - earning[0].length,
                y: 535,
                size: 10,
                font: customFont,
                color: rgb(0, 0, 0)
              });
            } else if (earning[0].length < 13 && earning[0].length >= 9) {
              firstPage.drawText("2" + earning[0], {
                x: 440 - 5 * (earning[0].length - 3) - earning[0].length,
                y: 535,
                size: 10,
                font: customFont,
                color: rgb(0, 0, 0)
              });
            } else if (earning[0].length < 9 && earning[0].length >= 4) {
              firstPage.drawText("" + earning[0], {
                x: 470 - 5 * (earning[0].length - 2) - earning[0].length,
                y: 535,
                size: 10,
                font: customFont,
                color: rgb(0, 0, 0)
              });
            } else {
              firstPage.drawText("4" + earning[0], {
                x: 440 - 5 * (earning[0].length - 1) - earning[0].length,
                y: 535,
                size: 10,
                font: customFont,
                color: rgb(0, 0, 0)
              });
            }

            firstPage.drawText("." + earning[1], {
              x: 474,
              y: 535,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            // ภาษี
            let tax_pay = this.thousandSep(element.tax_pay).split(".");
            if (tax_pay[0].length >= 13) {
              firstPage.drawText("1" + tax_pay[0], {
                x: 515 - 5 * (tax_pay[0].length - 4) - tax_pay[0].length,
                y: 535,
                size: 10,
                font: customFont,
                color: rgb(0, 0, 0)
              });
            } else if (tax_pay[0].length < 13 && tax_pay[0].length >= 9) {
              firstPage.drawText("2" + tax_pay[0], {
                x: 515 - 5 * (tax_pay[0].length - 3) - tax_pay[0].length,
                y: 535,
                size: 10,
                font: customFont,
                color: rgb(0, 0, 0)
              });
            } else if (tax_pay[0].length < 9 && tax_pay[0].length >= 4) {
              firstPage.drawText("" + tax_pay[0], {
                x: 540 - 5 * (tax_pay[0].length - 2) - tax_pay[0].length,
                y: 535,
                size: 10,
                font: customFont,
                color: rgb(0, 0, 0)
              });
            } else {
              firstPage.drawText("" + tax_pay[0], {
                x: 540 - 5 * (tax_pay[0].length - 1) - tax_pay[0].length,
                y: 535,
                size: 10,
                font: customFont,
                color: rgb(0, 0, 0)
              });
            }

            firstPage.drawText("." + tax_pay[1], {
              x: 545,
              y: 535,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });

            //ประเภทเงินได้ค่าธรรมเนียม(วัน)
            firstPage.drawText("", {
              x: 360,
              y: 520,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            firstPage.drawText("", {
              x: 444,
              y: 520,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            firstPage.drawText("", {
              x: 474,
              y: 520,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            firstPage.drawText("", {
              x: 515,
              y: 520,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            firstPage.drawText("", {
              x: 545,
              y: 520,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });

            //ประเภทเงินได้ค่าลิขสิทธิ์(วัน)
            firstPage.drawText("", {
              x: 360,
              y: 506,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            firstPage.drawText("", {
              x: 444,
              y: 506,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            firstPage.drawText("", {
              x: 474,
              y: 506,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            firstPage.drawText("", {
              x: 515,
              y: 506,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            firstPage.drawText("", {
              x: 545,
              y: 506,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });

            //ประเภทเงินได้ดอกเบี้ย(วัน)
            firstPage.drawText("", {
              x: 360,
              y: 492,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            firstPage.drawText("", {
              x: 444,
              y: 492,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            firstPage.drawText("", {
              x: 474,
              y: 492,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            firstPage.drawText("", {
              x: 515,
              y: 492,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            firstPage.drawText("", {
              x: 545,
              y: 492,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });

            //4.1(วัน)
            firstPage.drawText("", {
              x: 360,
              y: 435,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            firstPage.drawText("", {
              x: 444,
              y: 435,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            firstPage.drawText("", {
              x: 474,
              y: 435,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            firstPage.drawText("", {
              x: 515,
              y: 435,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            firstPage.drawText("", {
              x: 545,
              y: 435,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });

            //4.1.1(วัน)
            firstPage.drawText("", {
              x: 360,
              y: 420,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            firstPage.drawText("", {
              x: 444,
              y: 420,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            firstPage.drawText("", {
              x: 474,
              y: 420,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            firstPage.drawText("", {
              x: 515,
              y: 420,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            firstPage.drawText("", {
              x: 545,
              y: 420,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });

            //4.1.2(วัน)
            firstPage.drawText("", {
              x: 360,
              y: 405,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            firstPage.drawText("", {
              x: 444,
              y: 405,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            firstPage.drawText("", {
              x: 474,
              y: 405,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            firstPage.drawText("", {
              x: 515,
              y: 405,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            firstPage.drawText("", {
              x: 545,
              y: 405,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });

            //4.1.3(วัน)
            firstPage.drawText("", {
              x: 360,
              y: 390,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            firstPage.drawText("", {
              x: 444,
              y: 390,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            firstPage.drawText("", {
              x: 474,
              y: 390,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            firstPage.drawText("", {
              x: 515,
              y: 390,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            firstPage.drawText("", {
              x: 545,
              y: 390,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });

            firstPage.drawText("", {
              x: 360,
              y: 362,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            firstPage.drawText("", {
              x: 444,
              y: 362,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            firstPage.drawText("", {
              x: 474,
              y: 362,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            firstPage.drawText("", {
              x: 515,
              y: 362,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            firstPage.drawText("", {
              x: 545,
              y: 362,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });

            firstPage.drawText("", {
              x: 360,
              y: 332,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            firstPage.drawText("", {
              x: 439,
              y: 332,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            firstPage.drawText("", {
              x: 474,
              y: 332,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            firstPage.drawText("", {
              x: 510,
              y: 332,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            firstPage.drawText("", {
              x: 545,
              y: 332,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });

            firstPage.drawText("", {
              x: 360,
              y: 304,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            firstPage.drawText("", {
              x: 439,
              y: 304,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            firstPage.drawText("", {
              x: 474,
              y: 304,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            firstPage.drawText("", {
              x: 510,
              y: 304,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            firstPage.drawText("", {
              x: 545,
              y: 304,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });

            firstPage.drawText("", {
              x: 360,
              y: 275,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            firstPage.drawText("", {
              x: 439,
              y: 275,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            firstPage.drawText("", {
              x: 474,
              y: 275,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            firstPage.drawText("", {
              x: 510,
              y: 275,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            firstPage.drawText("", {
              x: 545,
              y: 275,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });

            firstPage.drawText("", {
              x: 360,
              y: 217,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            firstPage.drawText("", {
              x: 439,
              y: 217,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            firstPage.drawText("", {
              x: 474,
              y: 217,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            firstPage.drawText("", {
              x: 510,
              y: 217,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            firstPage.drawText("", {
              x: 545,
              y: 217,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });

            firstPage.drawText("", {
              x: 360,
              y: 202,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            firstPage.drawText("", {
              x: 439,
              y: 202,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            firstPage.drawText("", {
              x: 474,
              y: 202,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            firstPage.drawText("", {
              x: 510,
              y: 202,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            firstPage.drawText("", {
              x: 545,
              y: 202,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            // เงินเดือนรวม
            let sumearning = this.thousandSep(element.earning).split(
              "."
            );
            if (sumearning[0].length >= 13) {
              firstPage.drawText("1" + sumearning[0], {
                x: 431 - 5 * (sumearning[0].length - 4) - sumearning[0].length,
                y: 181,
                size: 10,
                font: customFont,
                color: rgb(0, 0, 0)
              });
            } else if (sumearning[0].length < 13 && sumearning[0].length >= 9) {
              firstPage.drawText("2" + sumearning[0], {
                x: 431 - 5 * (sumearning[0].length - 3) - sumearning[0].length,
                y: 181,
                size: 10,
                font: customFont,
                color: rgb(0, 0, 0)
              });
            } else if (sumearning[0].length < 9 && sumearning[0].length >= 4) {
              firstPage.drawText("" + sumearning[0], {
                x: 470 - 5 * (sumearning[0].length - 2) - sumearning[0].length,
                y: 181,
                size: 10,
                font: customFont,
                color: rgb(0, 0, 0)
              });
            } else {
              firstPage.drawText("4" + sumearning[0], {
                x: 431 - 5 * (sumearning[0].length - 1) - sumearning[0].length,
                y: 181,
                size: 10,
                font: customFont,
                color: rgb(0, 0, 0)
              });
            }

            firstPage.drawText("." + sumearning[1], {
              x: 474,
              y: 181,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });

            // ภาษีรวม
            let sumtax_pay = this.thousandSep(element.tax_pay).split(
              "."
            );
            if (sumtax_pay[0].length >= 13) {
              firstPage.drawText("1" + sumtax_pay[0], {
                x: 502 - 5 * (sumtax_pay[0].length - 4) - sumtax_pay[0].length,
                y: 181,
                size: 10,
                font: customFont,
                color: rgb(0, 0, 0)
              });
            } else if (sumtax_pay[0].length < 13 && sumtax_pay[0].length >= 9) {
              firstPage.drawText("2" + sumtax_pay[0], {
                x: 502 - 5 * (sumtax_pay[0].length - 3) - sumtax_pay[0].length,
                y: 181,
                size: 10,
                font: customFont,
                color: rgb(0, 0, 0)
              });
            } else if (sumtax_pay[0].length < 9 && sumtax_pay[0].length >= 4) {
              firstPage.drawText("" + sumtax_pay[0], {
                x: 540 - 5 * (sumtax_pay[0].length - 2) - sumtax_pay[0].length,
                y: 181,
                size: 10,
                font: customFont,
                color: rgb(0, 0, 0)
              });
            } else {
              firstPage.drawText("" + sumtax_pay[0], {
                x: 540 - 5 * (sumtax_pay[0].length - 1) - sumtax_pay[0].length,
                y: 181,
                size: 10,
                font: customFont,
                color: rgb(0, 0, 0)
              });
            }
            firstPage.drawText("." + sumtax_pay[1], {
              x: 545,
              y: 181,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            });
            this.tax = this.formatNumber(element.tax_pay);
            this.ArabicNumberToText(this.tax);
            firstPage.drawText("" + this.texttax, {
              x: 250,
              y: 160,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            }); //ยอดรวม
            firstPage.drawText("", {
              x: 240,
              y: 145,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            }); //กองทุนรวมสงเคราะห์
            firstPage.drawText("" + element.social_pay, {
              x: 370,
              y: 145,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            }); //ประกันสังคม
            firstPage.drawText("", {
              x: 503,
              y: 145,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            }); //กองทุนสำรองเลี้ยงชีพ

            firstPage.drawText("X", {
              x: 85,
              y: 122,
              size: 10,
              font: customFont,
              color: rgb(0, 0, 0)
            }); //ประกันสังคม
            console.log("tw" + i);
            console.log("t" + index);

            i += 742;

            k = index;

            await pdfDoc.save();
          }
        });
       
        const pdfDataUri = await pdfDoc.saveAsBase64({ dataUri: true });
         console.log(pdfDataUri)
        document.getElementById("pdf").src = pdfDataUri;
      }, 9000);
    },
    async showPDF(pdfDoc) {},
    thousandSep(nStr) {
      nStr = nStr.toFixed(2);
      nStr += "";
      var x = nStr.split(".");
      var x1 = x[0];
      var x2 = x.length > 1 ? "." + x[1] : "";
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, "$1" + "," + "$2");
      }
      return x1 + x2;
    },
    //*แปลงตัวเลขเป็นตัวหนังสือ */
    CheckNumber(Number) {
      var decimal = false;
      Number = Number.toString();
      Number = Number.replace(/ |,|บาท|฿/gi, "");
      for (var i = 0; i < Number.length; i++) {
        if (Number[i] == ".") {
          decimal = true;
        }
      }
      if (decimal == false) {
        Number = Number + ".00";
      }
      console.log("Number : ", Number);
      return Number;
    },
    ArabicNumberToText(Number) {
      console.log("Number: ", Number);
      var Number = this.CheckNumber(Number);
      var NumberArray = new Array(
        "ศูนย์",
        "หน่ึง",
        "สอง",
        "สาม",
        "ส่ี",
        "ห้า",
        "หก",
        "เจ็ด",
        "แปด",
        "เก้า",
        "สิบ"
      );
      var DigitArray = new Array(
        "",
        "สิบ",
        "ร้อย",
        "พัน",
        "หม่ืน",
        "แสน",
        "ล้าน"
      );
      var BahtText = "";
      if (isNaN(Number)) {
        return "ข้อมูลนำเข้าไม่ถูกต้อง";
      } else {
        if (Number - 0 > 9999999.9999) {
          return "ข้อมูลนำเข้าเกินขอบเขตที่ตั้งไว้";
        } else {
          Number = Number.split(".");
          if (Number[1].length > 0) {
            Number[1] = Number[1].substring(0, 2);
          }
          var NumberLen = Number[0].length - 0;
          for (var i = 0; i < NumberLen; i++) {
            var tmp = Number[0].substring(i, i + 1) - 0;
            if (tmp != 0) {
              if (i == NumberLen - 1 && tmp == 1) {
                BahtText += "เอ็ด";
              } else if (i == NumberLen - 2 && tmp == 2) {
                BahtText += "ย่ี";
              } else if (i == NumberLen - 2 && tmp == 1) {
                BahtText += "";
              } else {
                BahtText += NumberArray[tmp];
              }
              BahtText += DigitArray[NumberLen - i - 1];
            }
          }
          BahtText += "บาท";
          if (Number[1] == "0" || Number[1] == "00") {
            BahtText += "ถ้วน";
          } else {
            DecimalLen = Number[1].length - 0;
            for (var i = 0; i < DecimalLen; i++) {
              var tmp = Number[1].substring(i, i + 1) - 0;
              if (tmp != 0) {
                if (i == DecimalLen - 1 && tmp == 1) {
                  BahtText += "เอ็ด";
                } else if (i == DecimalLen - 2 && tmp == 2) {
                  BahtText += "ย่ี";
                } else if (i == DecimalLen - 2 && tmp == 1) {
                  BahtText += "";
                } else {
                  BahtText += NumberArray[tmp];
                }
                BahtText += DigitArray[DecimalLen - i - 1];
              }
            }
            BahtText += "สตางค์";
          }
          console.log("BahtText: ", BahtText);
          this.texttax = BahtText;
          return BahtText;
        }
      }
    }
  }
};
</script>

